"use client";

import React, { useRef, useEffect } from "react";
import Link from "next/link";
import { FaArrowRight } from "react-icons/fa";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import "../courses/free-courses.css";

// Register GSAP plugins
if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}

const HeroSection = () => {
  const heroRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate hero content
      gsap.fromTo(
        contentRef.current.children,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          stagger: 0.2,
          ease: "power3.out",
        }
      );
    }, heroRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={heroRef} className="hero-section">
      <div className="hero-bg bg-bg-course"></div>
      <div className="hero-overlay"></div>
      
      <div ref={contentRef} className="hero-content">
        <h1 className="hero-title">
          FREE <span>RESOURCES</span> FOR<br />EVERYONE
        </h1>
        
        <p className="hero-subtitle">
          Explore our free courses and resources to enhance your skills and kickstart your career in tech. 
          Learn at your own pace with high-quality content created by industry experts.
        </p>
        
        <Link href="/about" className="hero-button">
          Learn More <FaArrowRight className="ml-2" />
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
